var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFreightForwarding = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#129BF9",
  d: "M11.8 23c-.2 0-4.8-1-7.2-4.9-1.4-2.2-1.7-5-1-8.1-1.2.5-1.3.6-1.3.6l-.2-1s.3-.1 2.1-.9l1-.5-.3 1q-1.5 4.95.6 8.4C7.6 21 12 22 12 22z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "m20.3 19.6.6-.9c1.4-2 2.1-4.4 2-6.9-.3-5.1-5.2-7.8-5.2-7.8l.5-.9c.2.1 5.4 2.9 5.7 8.7.2 2.3-.4 4.6-1.6 6.6 1.4-.1 1.5-.1 1.5-.1l-.1 1s-.3 0-2.3.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "m13.8 20.6-.4-.5c-6.2-7.4-.1-15.4 0-15.5l.1-.2h.2c.6 0 1.9 2.7 1.9 2.7 1.3 2.7 2.7 7.9-1.5 13zm0-14.7c-1.2 1.8-4.2 7.6 0 13.2 4.2-5.7 1.1-11.4 0-13.2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M13.8 13.6c-2.6 0-5.2-.7-7.6-2.1-.2-.1-.3-.4-.2-.6s.4-.3.7-.2c4.4 2.6 9.7 2.6 14.1 0 .2-.1.5-.1.7.2.1.2.1.5-.2.7-2.3 1.3-4.9 2-7.5 2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M13.8 20.3c-4.4 0-7.9-3.6-7.9-7.9s3.6-7.9 7.9-7.9 7.9 3.6 7.9 7.9-3.6 7.9-7.9 7.9m0-14.8c-3.8 0-6.9 3.1-6.9 6.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9-3.1-6.9-6.9-6.9"
})));
export default SvgFreightForwarding;